import { Store } from '../../../types';
import { getLangVar } from '../../../util/misc';
import { GENERICA_SPRITE_URL } from '../../../config';
import { useState } from 'react';

export default function StoreCard({ store }: { store: Store }) {
    const [isOpen, setIsOpen] = useState(true);
    const name = getLangVar(store, 'name');
    const address = getLangVar(store, 'address') || '';
    const phone = getLangVar(store, 'phone') || '';
    const email = getLangVar(store, 'email') || '';
    const workHours = getLangVar(store, 'workHours') || '';
    return (
        <div className="shops__item menu-accordion menu-accordion--grey">
            <button
                className={
                    'menu-accordion__btn menu-accordion__btn--state' +
                    (isOpen ? ' ' : 'menu-accordion__btn--indents menu-accordion__btn--down')
                }
                type="button"
                onClick={() => setIsOpen(!isOpen)}
            >
                {name}
            </button>
            <div className={'shops__info' + (isOpen ? '' : ' menu-accordion__content--hide')}>
                {(address || store.address) && <p className="shops__address">{address || store.address}</p>}
                <ul className="shops__contacts">
                    {workHours && (
                        <li className="shops__contacts-item shops__contacts-item--time">
                            <svg width="24" height="24">
                                <use xlinkHref={GENERICA_SPRITE_URL + '#icon-time'} />
                            </svg>
                            {workHours}
                        </li>
                    )}
                    {phone && (
                        <li className="shops__contacts-item shops__contacts-item--phone">
                            <a href={'tel:' + phone}>
                                <svg width="24" height="24">
                                    <use xlinkHref={GENERICA_SPRITE_URL + '#icon-phone'} />
                                </svg>
                                {phone}
                            </a>
                        </li>
                    )}
                    {store.url && (
                        <li className="shops__contacts-item shops__contacts-item--site">
                            <a href={store.url}>
                                <svg width="24" height="24">
                                    <use xlinkHref={GENERICA_SPRITE_URL + '#icon-site'} />
                                </svg>
                                {store.url}
                            </a>
                        </li>
                    )}
                    {email && (
                        <li className="shops__contacts-item shops__contacts-item--mail">
                            <a href={'mailto:' + email}>
                                <svg width="24" height="24">
                                    <use xlinkHref={GENERICA_SPRITE_URL + '#icon-mail'} />
                                </svg>
                                {email}
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
